import { render, staticRenderFns } from "./DisplaySettings.vue?vue&type=template&id=b8b1c14e&scoped=true"
import script from "./DisplaySettings.vue?vue&type=script&lang=js"
export * from "./DisplaySettings.vue?vue&type=script&lang=js"
import style0 from "./DisplaySettings.vue?vue&type=style&index=0&id=b8b1c14e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b1c14e",
  null
  
)

export default component.exports